import React from 'react';
import { Box, Container, Grid, Paper, Stack, Typography, Alert, CircularProgress } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';
import MainLayout from '../../../components/layout/MainLayout';
import { staffApi, Department } from '../api';

const DepartmentsPage: React.FC = () => {
  const [departments, setDepartments] = React.useState<Department[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    loadDepartments();
  }, []);

  const loadDepartments = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await staffApi.listDepartments();
      setDepartments(data);
    } catch (err: any) {
      setError(err.message || 'Failed to load departments');
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} spacing={2} sx={{ mb: 3 }}>
          <Box>
            <h2 style={{ margin: 0 }}>Departments</h2>
            <p style={{ margin: '4px 0 0 0', color: '#666', fontSize: '14px' }}>View organizational units and staff assignment</p>
          </Box>
        </Stack>

        {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={2}>
            {departments.map((dept) => (
              <Grid key={dept.id} item xs={12} sm={6} md={4}>
                <Paper sx={{ p: 2.5, borderRadius: 2, cursor: 'pointer', '&:hover': { boxShadow: 3 } }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>{dept.name}</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>{dept.description || 'No description'}</Typography>
                  <Typography variant="caption" color="primary" sx={{ fontWeight: 600 }}>
                    Staff count: {dept.staffCount || 0}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </MainLayout>
  );
};

export default DepartmentsPage;
